/*eslint no-extend-native: ["error", { "exceptions": ["String"] }]*/ 

declare global {
    interface String {
      replaceAll(from: string, to: string): string;
      interpolate(values: Array<[string, string]>): string;
      interpolate(values: Map<string, string>): string;
      equalsIgnoreCase(value: string): boolean;
    }
  }
  
  if (!String.prototype.interpolate) {
    String.prototype.interpolate = function (this: string, values: Array<[string, string]> | Map<string, string>) {
      let result = this;
      if (values instanceof Map) {
        values.forEach((value, key) => {
          result = result.replaceAll('{' + key + '}', value);
        });
      } else if (values instanceof Array) {
        values.forEach((x) => {
          const [key, value] = x;
          result = result.replaceAll('{' + key + '}', value);
        });
      }
  
      return result;
    };
  }
  
  if (!String.prototype.replaceAll) {
    String.prototype.replaceAll = function (this: string, from: string, to: string) {
      return this.split(from).reduce((a, b) => a + to + b);
    };
  }
  
  if (!String.prototype.equalsIgnoreCase) {
    String.prototype.equalsIgnoreCase = function (this: string, value: string) {
      const x = !!this ? this.toLocaleLowerCase() : this;
      const y = !!value ? value.toLocaleLowerCase() : value;
      return x === y;
    };
  }
  
  export default {};